export default __webpack_public_path__ + "c4d53a7931c9c1e7b351cebe39206668.png";